import { useState, useEffect } from "react";

const EMPTY = {
  title: "", subtitle: "", description: "", category: "",
  source_url: "", keywords: "", seo_title: "", seo_desc: "", slug: "",
};

export default function StorefrontDrawer({ storefront, onSave, onClose }) {
  const [form, setForm]   = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const [error, setError]   = useState("");

  useEffect(() => {
    setForm(storefront ? { ...EMPTY, ...storefront } : EMPTY);
    setError("");
  }, [storefront]);

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.title.trim()) { setError("Title is required"); return; }
    setSaving(true);
    setError("");
    try {
      await onSave(form);
      onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  const isEdit = !!storefront?.id;

  return (
    <div className="drawer-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="drawer" role="dialog" aria-modal="true"
           aria-label={isEdit ? "Edit storefront" : "New storefront"}>
        <button className="drawer-close" onClick={onClose} aria-label="Close">✕</button>

        <h2 className="drawer-title">{isEdit ? "Edit Storefront" : "New Storefront"}</h2>

        <form onSubmit={handleSubmit} style={{display:"flex",flexDirection:"column",gap:16}}>

          <div className="form-group">
            <label className="form-label">Page Title *</label>
            <input className="form-input" value={form.title} onChange={set("title")}
              placeholder="Best Child Carrier Head Supports" required />
          </div>

          <div className="form-group">
            <label className="form-label">Subtitle</label>
            <input className="form-input" value={form.subtitle} onChange={set("subtitle")}
              placeholder="Curated picks for confident adventures" />
          </div>

          <div className="form-group">
            <label className="form-label">Description</label>
            <textarea className="form-textarea" value={form.description} onChange={set("description")}
              placeholder="Introduce this collection to your readers..." rows={4} />
          </div>

          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Category</label>
              <input className="form-input" value={form.category} onChange={set("category")}
                placeholder="Baby Carrier Accessories" />
            </div>
            <div className="form-group">
              <label className="form-label">URL Slug</label>
              <input className="form-input" value={form.slug} onChange={set("slug")}
                placeholder="auto-generated from title" />
              <span className="form-hint">yourdomain.com/s/<strong>{form.slug || "slug"}</strong></span>
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Amazon UK Source URL</label>
            <input className="form-input" type="url" value={form.source_url} onChange={set("source_url")}
              placeholder="https://www.amazon.co.uk/best-sellers/zgbs/baby/..." />
            <span className="form-hint">Category, best-sellers, browse-node, or search page. Browse node ID is extracted automatically.</span>
          </div>

          <div className="form-group">
            <label className="form-label">Search Keywords <span style={{fontWeight:400,textTransform:"none"}}>(fallback if no browse node)</span></label>
            <input className="form-input" value={form.keywords} onChange={set("keywords")}
              placeholder="baby carrier head support" />
          </div>

          <div className="form-group">
            <label className="form-label">SEO Title</label>
            <input className="form-input" value={form.seo_title} onChange={set("seo_title")}
              placeholder="Best Baby Carrier Head Supports UK 2024" />
          </div>

          <div className="form-group">
            <label className="form-label">SEO Description</label>
            <textarea className="form-textarea" value={form.seo_desc} onChange={set("seo_desc")}
              placeholder="Meta description shown in search results..." rows={2} />
          </div>

          {error && <p className="form-error">⚠ {error}</p>}

          <div style={{display:"flex",gap:10,marginTop:4}}>
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? <span className="spinner" /> : (isEdit ? "Save Changes" : "Create Storefront")}
            </button>
            <button type="button" className="btn btn-ghost" onClick={onClose}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
}
